import React from 'react'

import { Radio, Icon } from 'antd'

import colors from '../../../../components/hocs/colors'
// import sendFullStoryEvent from '../../../../utils/analytics/sendFullStoryEvent'
// import fullstory from '../../../../utils/constants/fullstory'
import { COMPANY_SORT_OPTIONS } from '../tabs/EmployerTrends/hooks/useCompanyTrends'

const CompanyTrendSorter = ({ currentCompanies, onChange }) => {
  const handleKeyDown = event => {
    if (event.key !== 'Enter') return
    event.preventDefault()
    onChange(event.target.value)
  }

  return (
    <div style={{ float: 'right' }} onKeyDown={handleKeyDown}>
      <Radio.Group
        aria-label="Sort employer trends"
        onChange={e => {
          onChange(e.target.value)
          // const eventProperties = {
          //   trend_sorter_str: selectedFilter,
          // }
          // sendFullStoryEvent(fullstory.eventNames.trendingClick, eventProperties)
        }}
      >
        <span data-testid="volume-sort">
          <Radio.Button
            checked={currentCompanies === COMPANY_SORT_OPTIONS.VOLUME_DESC}
            value={COMPANY_SORT_OPTIONS.VOLUME_DESC}
            aria-label="Sort by volume"
          >
            <Icon
              type="down-circle"
              aria-hidden="true"
              style={{
                color: colors.blue3,
                fontSize: 18,
                opacity: 0.8,
                verticalAlign: '0.15em',
              }}
            />
            <span className="legend-label" style={{ color: colors.blue3 }} aria-hidden="true">
              Volume
            </span>
          </Radio.Button>
        </span>
        <span data-testid="trending-up-sort">
          <Radio.Button
            checked={currentCompanies === COMPANY_SORT_OPTIONS.TRENDING_UP}
            value={COMPANY_SORT_OPTIONS.TRENDING_UP}
            aria-label="Sort by trending up"
          >
            <Icon
              type="rise"
              aria-hidden="true"
              style={{
                color: colors.green1,
                fontSize: 18,
                opacity: 0.8,
                verticalAlign: '0.15em',
              }}
            />
            <span className="legend-label" style={{ color: colors.blue3 }} aria-hidden="true">
              Trending Up
            </span>
          </Radio.Button>
        </span>
        <span data-testid="trending-down-sort">
          <Radio.Button
            checked={currentCompanies === COMPANY_SORT_OPTIONS.TRENDING_DOWN}
            value={COMPANY_SORT_OPTIONS.TRENDING_DOWN}
            aria-label="Sort by trending down"
          >
            <Icon
              type="fall"
              aria-hidden="true"
              style={{
                color: colors.red1,
                fontSize: 18,
                opacity: 0.8,
                verticalAlign: '0.15em',
              }}
            />
            <span className="legend-label" style={{ color: colors.blue3 }} aria-hidden="true">
              Trending Down
            </span>
          </Radio.Button>
        </span>
      </Radio.Group>
    </div>
  )
}

export default CompanyTrendSorter
